import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en-US.json';
import fr from '../locales/fr-CA.json';
import es from '../locales/es-ES.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    resources: {
      'en-US': {
        translation: en,
      },
      'fr-CA': {
        translation: fr,
      },
      'es-ES': {
        translation: es,
      },
    },
    ns: ['translation'],
    defaultNS: 'translation',
    returnObjects: true,
    debug: true,
    react: {
      wait: true,
      useSuspense: true,
    },
  });

i18n.languages = ['en-US', 'fr-CA', 'es-ES'];

export default i18n;
